import { Box, Container } from "@mui/material";
import { createContext, useState } from "react";
import { Outlet } from 'react-router-dom';

export const AppContext = createContext();
export default function Base() {
    const [username, setUsername] = useState('');
    const [points, setPoints] = useState(0);
    const [coins, setCoins] = useState(0);
    const [footprint, setFootprint] = useState(0);
    const [siteversion, setSiteVersion] = useState(null);

    // For setting browser cookies from the UI pages that handle login and logout
    const setSessionCookie = (email, token='') => {
        localStorage.setItem('icare_se', email);
        localStorage.setItem('icare_st', token);
    }
    
    return (
        <Box maxWidth={true} sx={{ backgroundColor: '#eee' }}>
            <AppContext.Provider 
                value={{ 
                    setSessionCookie: setSessionCookie,
                    usernameState: username,
                    setUsername: setUsername,
                    pointsState: points,   // for moving up Levels
                    setPoints: setPoints,
                    coinsState: coins,      // for claiming rewards
                    setCoins: setCoins,
                    footprintState: footprint, // for carbon footprint
                    setFootprint: setFootprint,
                    siteversionState: [siteversion, setSiteVersion],
                }} 
            >
            <Container maxWidth={'xs'} sx={{ backgroundColor: 'white', minHeight: '100vh', display: 'flex', flexDirection: 'column', pb: 10 }}>
                <Outlet />
            </Container>
            </AppContext.Provider>
        </Box>
    )
}